import script from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=e885ba60&lang=css"

const __exports__ = script;

export default __exports__